import L from 'leaflet';

export function initCoastguardPanel(map: L.Map) {
    // 1. Inject HTML
    const panelHtml = `
<div id="coastguard-panel" style="display:none;">
    <h3>Coastguard Tools</h3>
    <div style="border:1px solid #333; border-radius:8px; padding:1em;">
        <div style="display: flex; align-items: center; margin-bottom: 0.5em;">
            <button id="cg-url-creator-btn" style="flex-grow: 1; margin-right: 0.5em;">URL Creator</button>
            <button id="training-mode-status-btn" title="Training Mode Status" style="width: 30px; height: 30px; padding: 0; font-size: 1.2em;" disabled>🎓</button>
        </div>
        <div style="display: flex; align-items: center; margin-bottom: 0.5em;">
            <button id="cg-search-patterns-btn" style="flex-grow: 1; margin-right: 0.5em;">Search Patterns</button>
            <button id="clear-search-pattern-btn" title="Clear Search Pattern" style="width: 30px; height: 30px; padding: 0; font-size: 1.2em;" disabled>❌</button>
        </div>
        <div style="display: flex; align-items: center;">
            <button id="cg-passage-planner-btn" style="flex-grow: 1; margin-right: 0.5em;">Passage Planner</button>
            <button id="clear-passage-plan-btn" title="Clear Passage Plan" style="width: 30px; height: 30px; padding: 0; font-size: 1.2em;" disabled>❌</button>
        </div>
    </div>
    <div style="margin-top:1em;">
        <button id="close-coastguard-btn">Close</button>
    </div>
</div>
    `;

    const appContainer = document.getElementById('app');
    if (appContainer) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = panelHtml;
        appContainer.appendChild(tempDiv.firstElementChild!);
    }

    // 2. Get References
    const panel = document.getElementById('coastguard-panel')!;
    const closeBtn = document.getElementById('close-coastguard-btn')!;
    const urlCreatorBtn = document.getElementById('cg-url-creator-btn')!;
    const searchPatternsBtn = document.getElementById('cg-search-patterns-btn')!;
    const passagePlannerBtn = document.getElementById('cg-passage-planner-btn')!;
    const trainingModeStatusBtn = document.getElementById('training-mode-status-btn') as HTMLButtonElement;
    const clearSearchPatternBtn = document.getElementById('clear-search-pattern-btn') as HTMLButtonElement;
    const clearPassagePlanBtn = document.getElementById('clear-passage-plan-btn') as HTMLButtonElement;

    // Logic to update button states
    const updateButtonStates = () => {
        const params = new URLSearchParams(window.location.search);
        const unit = params.get('unit');
        const level = params.get('level');
        const psp = params.get('psp');
        const passage = params.get('ppp');

        // Training mode button
        if (unit || level) {
            trainingModeStatusBtn.disabled = false;
            trainingModeStatusBtn.title = "Training Mode Active. Click to open exit options.";
        } else {
            trainingModeStatusBtn.disabled = true;
            trainingModeStatusBtn.title = "Training Mode Inactive";
        }

        // Search pattern button
        if (psp) {
            clearSearchPatternBtn.disabled = false;
            clearSearchPatternBtn.title = "Clear Search Pattern";
        } else {
            clearSearchPatternBtn.disabled = true;
            clearSearchPatternBtn.title = "No Search Pattern loaded";
        }

        // Passage plan button
        if (passage) {
            clearPassagePlanBtn.disabled = false;
            clearPassagePlanBtn.title = "Clear Passage Plan";
        } else {
            clearPassagePlanBtn.disabled = true;
            clearPassagePlanBtn.title = "No Passage Plan loaded";
        }
    };

    // 3. Attach Listeners
    map.getContainer().addEventListener('open-coastguard-panel', () => {
        if (panel.style.display === 'block') {
            panel.style.display = 'none';
        } else {
            map.getContainer().dispatchEvent(new CustomEvent('close-other-panels', { detail: 'coastguard-panel' }));
            updateButtonStates(); // Update states when panel is opened
            panel.style.display = 'block';
        }
    });

    map.getContainer().addEventListener('close-other-panels', (e: any) => {
        if (e.detail !== 'coastguard-panel') {
            panel.style.display = 'none';
        }
    });

    closeBtn.addEventListener('click', () => {
        panel.style.display = 'none';
    });

    urlCreatorBtn.addEventListener('click', () => {
        map.getContainer().dispatchEvent(new CustomEvent('open-settings-panel'));
        panel.style.display = 'none';
    });

    searchPatternsBtn.addEventListener('click', () => {
        map.getContainer().dispatchEvent(new CustomEvent('open-psp-planner-panel')); // Directly open PSP Planner
        panel.style.display = 'none';
    });

    passagePlannerBtn.addEventListener('click', () => {
        map.getContainer().dispatchEvent(new CustomEvent('open-passage-planner-panel'));
        panel.style.display = 'none';
    });

    trainingModeStatusBtn.addEventListener('click', () => {
        map.getContainer().dispatchEvent(new CustomEvent('open-training-panel'));
        panel.style.display = 'none';
    });

    clearSearchPatternBtn.addEventListener('click', () => {
        const params = new URLSearchParams(window.location.search);
        params.delete('psp');
        window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
        window.location.reload(); // Easiest way to clear the state from the map
    });

    clearPassagePlanBtn.addEventListener('click', () => {
        const params = new URLSearchParams(window.location.search);
        params.delete('ppp');
        window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
        window.location.reload(); // Easiest way to clear the state from the map
    });

    // Initial state update (this will run once when the app loads, but the real update happens when the panel is opened)
    updateButtonStates();
}
